import {Component, HostBinding} from '@angular/core';
import {I18nKeyEnum} from '../shared/models/language.model';
import {ValidatorsErrorEnum} from '../shared/models/form.model';
import {combineLatest, Subscription} from 'rxjs';
import {FormControl, FormGroup} from '@angular/forms';
import {CrawlerService} from '../shared/services/crawler.service';
import {AccountService} from '../shared/services/account.service';
import {CategoryEnum, User} from '../shared/models/account.model';
import {VoiceBotService} from '../shared/services/voice-bot.service';
import {IconEnum} from '../shared/models/assets.model';
import {FreeTrialService} from '../shared/services/free-trial.service';

@Component({
    selector: 'app-test-call',
    standalone: false,
    templateUrl: './test-call.component.html',
    styleUrl: './test-call.component.scss'
})
export class TestCallComponent {
    private user: User | undefined;
    protected readonly I18nKeyEnum = I18nKeyEnum;
    protected readonly validatorsErrorEnum = ValidatorsErrorEnum;
    protected readonly ICONS = IconEnum;
    protected readonly CategoryEnum = CategoryEnum;
    @HostBinding('class.test-call') default = true;
    @HostBinding('class.missing-basic-data') missingBasicData = true;
    @HostBinding('class.test-call-running') testCallRunning = false;
    public subscriptions = new Subscription();
    public callbackNumberCtrl = new FormControl();
    public callbackForm = new FormGroup({
        callbackNumber: this.callbackNumberCtrl
    });
    public email: string | undefined;
    public whatsAppNumber: string | undefined;
    readyToCall = false;
    public categoryDone = {
        general: false,
        knowledgeBase: false
    };
    
    constructor(private readonly crawlerService: CrawlerService,
                private readonly accountService: AccountService,
                private readonly freeTrialService: FreeTrialService,
                private readonly voiceBotService: VoiceBotService) {
        this.initSubscriptions();
    }
    
    initTestCall() {
        if (!this?.user?.phoneService?.phoneServiceId || !this.callbackNumberCtrl.value) {
            this.callbackForm.markAsTouched();
            return;
        }
        this.voiceBotService.initTestCall(this.callbackNumberCtrl.value, this.user.phoneService.phoneServiceId);
    }
    
    public toggleCategory(category: CategoryEnum) {
        this.accountService.openCategory(category);
    }
    
    private initSubscriptions() {
        this.subscriptions.add(this.freeTrialService.freeTrialInitialized$.subscribe((state) => {
            this.missingBasicData = !state;
        }));
        
         this.subscriptions.add(this.voiceBotService.testCallRunning$.subscribe((state) => {
            this.testCallRunning = state;
        }));
        
        this.subscriptions.add(combineLatest([
            this.accountService.greetingSaved$,
            this.voiceBotService.voiceBotTypesSaved$
        ]).subscribe((data) => {
                this.categoryDone.general = !!data[0] && !!data[1];
            }
        ));
        
        this.subscriptions.add(combineLatest([
            this.accountService.greetingSaved$,
            this.voiceBotService.voiceBotTypesSaved$,
            this.crawlerService.summary$
        ]).subscribe((data) => {
                this.readyToCall = !!data[0] && !!data[1] && !!data[2];
            }
        ));
        
        this.subscriptions.add(this.crawlerService.summary$.subscribe((summary) => {
            this.categoryDone.knowledgeBase = !!summary && summary.length > 0;
        }));
        
        this.subscriptions.add(this.accountService.user$.subscribe((user) => {
            this.user = user;
            this.email = user?.userAccount?.email;
            this.whatsAppNumber = user?.userAccount?.contactNumber;
            this.callbackNumberCtrl.setValue(user?.userAccount?.contactNumber);
        }));
    }
}
